import { Logger } from "src/app/core/logger";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, of, tap } from "rxjs";
import { ExceptionService } from "src/app/core/exception.service";
import { FormInformation } from "../../../models/api/form-information.model";
import { Config } from "src/app/config";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: 'root',
})
export class AutoSaveService {

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService,
    private toastr: ToastrService,
    private logger: Logger
  ) {
  }

  /**
   * @returns form information autosaved upon call
   */
   autosave(formInformation:FormInformation): Observable<any> {
    let baseurl = '';
    if (Config && Config.app) {
        baseurl = Config.projectApiUrl;
        baseurl = `${baseurl}/Form/autosave`;                
    }

    // const baseurl = `${Config.app.projectApiUrl}/form/autosave`;
    // this.logger.log("post (" + baseurl +")");
    const options = {
        headers: new HttpHeaders()
        .set('Accept', '*/*'),
        responseType: 'text' as 'json'
    }; 
    return this.http
      .post<FormInformation>(baseurl, formInformation, options)
      .pipe(
        map( res=> {
          this.logger.log('Autosave executed=' + res);
          return res;
        }),
        catchError(res => {
          if (res.status === 500) {
            this.logger.warn("Autosave: Error ["+res.status+"]: "+res.error);
            this.toastr.warning(res.error);
            return of(false);
          } else if (res.status === 400) {
            this.logger.warn("Autosave: Error ["+res.status+"]: "+res.error);
            return of(false);
          } else {            
            return this.exceptionService.catchBadResponse(res);
          }
        }));      
  }

  /**
   * @returns form information autosaved upon call
   */
  public getExistingAutosave(formVersionId:number): Observable<any> {
      const apiUrl = `${Config.projectApiUrl}/Form/autosave/${formVersionId}`;
      // this.logger.log("get (" + apiUrl +")");
      const options = {
          headers: new HttpHeaders().set('Accept', '*/*'),
          responseType: 'text' as 'json'
      }; 
      return this.http
        .get<FormInformation>(apiUrl, options)
        .pipe(
          map( form => {
            if (form) {
              // this.logger.log('Response retrieved with Id=' + form.toString());
              this.toastr.info('Autosave retrieved');
            }
            return form;
          }),
          catchError(res => {
            if (res.status === 404) {
              this.logger.warn("Autosave retrieve error ["+res.status+"]: "+res.error);
              // No autosave found is expected sometimes. No need to show toast
              // this.toastr.warning('Autosave not found');
              return of(false);
            } else {
              return this.exceptionService.catchBadResponse(res);
            }
          }));      
  }
}